import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import { find } from 'lodash';

import { PriceGroupButtons, MembershipCardConditionPopup } from '../../organisms/memberships';
import { PromoProposalControl } from '../../organisms/promotions/promo-proposal-control';

// Utils
import { analyseAddToCartErrorMessage } from '../../../logic';

// Types
import { PlaceToGoEnum } from '../../organisms/buytickets/types';

interface MembershipCardPurchaseButtonsProps {
    eventDateID: number;
    priceGroups: {
        id: number;
        creditCardCondition: string;
    }[];
    promoInfo?: any;
    onPromoUpdated?: (promoCode: string) => void;
    onNewCardAdded: (placeToGo: typeof PlaceToGoEnum) => void;
    onContentChange: () => void;

}

export const MembershipCardPurchaseButtons = createClass<MembershipCardPurchaseButtonsProps>({
    displayName: "MembershipCardPurchaseButton",

    propTypes: {
        eventDateID: PropTypes.number.isRequired,
        priceGroups: PropTypes.array.isRequired,
        promoInfo: PropTypes.object,
        onPromoUpdated: PropTypes.func,
        onNewCardAdded: PropTypes.func,
        onContentChange: PropTypes.func
    },

    getInitialState() {
        return { errorMessage: null, 
            addingCard: false,
            showPopupMessageCreditCardCondition: false,
        };
    },

    componentDidMount() {
        this.raiseContentChanged();
    },

    componentDidUpdate() {
        this.raiseContentChanged();
    },

    componentWillUnmount() {
        if (this.membershipCardRequest != null) this.membershipCardRequest.abort();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    addMemberShipCardToCart(priceGroupID, placeToGo) {
        this.setState({ addingCard: true, errorMessage: null, showPopupMessageCreditCardCondition: false });
        
        tsapp.mvcapi.postCtl("buyticket/addmembershipcardtocart", { 
            eventDateID: this.props.eventDateID,
            priceGroupID: priceGroupID,
            desiredTicketQty: 1,
            //resetTemporarySelectedTickets: false 
        })
        
        .success(function() {
            if(typeof window.RefreshCartIFrame != 'undefined') 
                // We want to disable that rule, since it's a global function
            //eslint-disable-next-line sonarjs/new-cap
            window.RefreshCartIFrame(); // This is a global site function. We will have to do something for integrations that don't have a small cart!
            
            if(typeof window.RefreshCart !== 'undefined') 
                // We want to disable that rule, since it's a global function
                //eslint-disable-next-line sonarjs/new-cap
                window.RefreshCart();

            if(this.props.onNewCardAdded != null)
                this.props.onNewCardAdded(placeToGo);
        }.bind(this))
        
        .notSuccess(
            function(data) {
                this.setState({
                    addingCard: false,
                    errorMessage: analyseAddToCartErrorMessage(data)
                });
            }
        .bind(this));
    },

    handleAddMembershipCardToCart(selectedPriceGroupId, placeToGo) {
        const selectedPriceGroup = find(this.props.priceGroups, ['id', selectedPriceGroupId]);

        if(!selectedPriceGroup.creditCardCondition)
            this.addMemberShipCardToCart(selectedPriceGroup.id, placeToGo);
        else {
            this.setState({ showPopupMessageCreditCardCondition: true, selectedPriceGroup: selectedPriceGroup });
        }
    },

    handlePopupClose() {
        this.setState({ showPopupMessageCreditCardCondition: false });
    },

    render() {
        let errorAlert;
        if(this.state.errorMessage != null)
            errorAlert = <div className="alert alert-danger">{this.state.errorMessage}</div>;

        const promoInfo = (this.props.promoInfo != null) ? this.props.promoInfo : undefined;
        
        return <>
            {
                promoInfo && <div className="row text-center">
                    <br/>
                    <PromoProposalControl 
                        promoInfo={promoInfo}
                        hiddenPromo={this.props.hiddenPromo}
                        showProposalMessage={true}
                        onPromoUpdated={this.props.onPromoUpdated}
                        onContentChange={this.props.onContentChange}
                        isAPackageSale={false}
                    />
                </div>
            }
            <div className="row">
                <br/>

                <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 text-center">
                    {errorAlert}
                </div>

                <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 text-center">
                    <PriceGroupButtons
                        priceGroups={this.props.priceGroups}
                        onClick={(priceGroupId) => this.handleAddMembershipCardToCart(priceGroupId, PlaceToGoEnum.GO_TO_CHECKOUT)}
                        processing={this.state.addingCard}
                    />
                </div>
                <div ref={this.refs.popupContainer}></div>
                { this.state.showPopupMessageCreditCardCondition && this.state.selectedPriceGroup && <MembershipCardConditionPopup
                    container={this.refs.popupContainer}
                    creditCardCondition={this.state.selectedPriceGroup.creditCardCondition}
                    onConfirmPaidWithCreditCardCondition={() => this.addMemberShipCardToCart(this.state.selectedPriceGroup.id, PlaceToGoEnum.GO_TO_CHECKOUT)}
                    onPopupClose={this.handlePopupClose}
                />}
            </div>
        </>;
    }

});